import React from 'react';
import {
  useState,
} from 'react';
import {
  Card,
  TextStyle,
  Button,
  Checkbox,
  Stack,
  ResourceItem,
  ResourceList,
  ActionList,
  Popover
} from '@shopify/polaris';
import { GenieTag } from '../../../components/GenieTag';
import Pager from './Pager';
import ResourceCounts from './ResourceCounts';

function resolveItemIds({ id }) {
  return id;
}

function ProductCardView(props) {

  const [showTags, setShowTags] = useState(true);
  const [itemsPerRow, setItemsPerRow] = useState(3);
  const [popoverActive, setPopoverActive] = useState(false);

  function onResourceItemClick(id) {

    var index = props.selectedItems.indexOf(id);

    if (index === -1) {
      let newSelected = [...props.selectedItems, id];
      props.onSelectionChange(newSelected);
    }
    else {
      let newSelected = [
        ...props.selectedItems.slice(0, index),
        ...props.selectedItems.slice(index + 1)
      ];
      props.onSelectionChange(newSelected);
    }
  }

  const resourcesToRender = props.resources.map(_ => {
    return {
      ..._,
      selected: props.selectedItems.includes(_.id),
      onItemClick: (__) => { onResourceItemClick(_.id) }
    }
  });

  function renderItem(item) {
    const { id, image, title, tags, selected, onItemClick } = item;
    var tagElements = tags.map(_ => <GenieTag selectable={false}>{_}</GenieTag>);
    var cardClasses = "resourceCard";

    return (
      <ResourceItem
        id={id}
        key={id}
        onClick={onItemClick}
        accessibilityLabel={`View details for ${title}`}>
        <div className={cardClasses}>
          <Stack vertical alignment="center">
            <Stack alignment='center' distribution='leading'>
              <Stack.Item>
                <Checkbox checked={selected} onChange={onItemClick}></Checkbox>
              </Stack.Item>
              <Stack.Item fill>
                <TextStyle variation="strong">{title}</TextStyle>
              </Stack.Item>
            </Stack>
            <Stack.Item>
              <img src={image} alt="product" width="100%"></img>
            </Stack.Item>
            {showTags &&
              <Stack.Item>
                <Stack alignment="leading" distribution="leading" spacing="tight">
                  {tagElements}
                </Stack>
              </Stack.Item>}
          </Stack>
        </div>
      </ResourceItem>
    );
  }

  let itemsPerRowClass = "three";

  if (itemsPerRow === 4) {
    itemsPerRowClass = "four";
  }

  if (itemsPerRow === 5) {
    itemsPerRowClass = "five";
  }

  const activator = (
    <Button disclosure plain onClick={() => { setPopoverActive(!popoverActive) }}>
      Items Per Row
    </Button>
  );
  const newButton = (<Popover
    active={popoverActive}
    activator={activator}
    autofocusTarget="first-node"
    onClose={() => { setPopoverActive(!popoverActive) }}
  >
    <ActionList
      actionRole="menuitem"
      items={[
        { content: '3', onAction: () => { setItemsPerRow(3); setPopoverActive(false); } },
        { content: '4', onAction: () => { setItemsPerRow(4); setPopoverActive(false); } },
        { content: '5', onAction: () => { setItemsPerRow(5); setPopoverActive(false); } },
      ]}
    />
  </Popover>);

  return (
    <Card title="Products"
      actions={[
        {
          content: showTags ? 'Hide Product Tags' : 'Show Product Tags',
          onAction: () => setShowTags(!showTags)
        },
        // {
        //   content: refreshButton,
        //   onAction: () => setShowTags(!showTags)
        // },
        {
          content: newButton,
          // onAction: () => setShowTags(!showTags)
        },

      ]}>
      <Card.Section>
        <ResourceCounts
          totalResourceCount={props.totalResources}
          matchingResourceCount={props.totalMatchingResources}
          currentResourceCount={resourcesToRender.length} />
      </Card.Section>
      <Pager
        currentPage={props.currentPage}
        totalResources={props.totalMatchingResources}
        disabled={props.isLoading}
        onPrevious={props.onRequestPreviousPage}
        onNext={props.onRequestNextPage}
      />
      <br />
      <div className={"tagExplorer-resourceViewHost " + itemsPerRowClass}>
        <ResourceList
          selectable
          hasMoreItems={(props.currentPage * 50) < props.totalMatchingResources}
          isFiltered={props.totalMatchingResources < props.totalResources}
          totalItemsCount={props.totalMatchingResources}
          loading={props.isLoading}
          items={props.isLoading ? [] : resourcesToRender}
          renderItem={renderItem}
          resolveItemId={resolveItemIds}
          selectedItems={props.allSelected ? "All" : props.selectedItems}
          onSelectionChange={props.onSelectionChange}
          promotedBulkActions={props.promotedBulkActions}
          sortValue="DATE_CREATED_DESC"
          sortOptions={[
            { label: 'Created (newest first)', value: 'DATE_CREATED_DESC' },
          ]}
          filterControl={props.filterControl}
        />
      </div>
      <Pager
        currentPage={props.currentPage}
        totalResources={props.totalMatchingResources}
        disabled={props.isLoading}
        onPrevious={props.onRequestPreviousPage}
        onNext={props.onRequestNextPage}
      />
      <br />
    </Card>
  );

}

export default ProductCardView;